var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/rc-util/lib/warning.js
var require_warning = __commonJS({
  "../../node_modules/rc-util/lib/warning.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.call = call;
    exports.default = void 0;
    exports.note = note;
    exports.noteOnce = noteOnce2;
    exports.preMessage = void 0;
    exports.resetWarned = resetWarned;
    exports.warning = warning;
    exports.warningOnce = warningOnce;
    var warned = {};
    var preWarningFns = [];
    var preMessage = exports.preMessage = function preMessage2(fn) {
      preWarningFns.push(fn);
    };
    function warning(valid, message) {
      if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
        var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
          return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "warning");
        }, message);
        if (finalMessage) {
          console.error("Warning: ".concat(finalMessage));
        }
      }
    }
    function note(valid, message) {
      if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
        var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
          return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "note");
        }, message);
        if (finalMessage) {
          console.warn("Note: ".concat(finalMessage));
        }
      }
    }
    function resetWarned() {
      warned = {};
    }
    function call(method, valid, message) {
      if (!valid && !warned[message]) {
        method(false, message);
        warned[message] = true;
      }
    }
    function warningOnce(valid, message) {
      call(warning, valid, message);
    }
    function noteOnce2(valid, message) {
      call(note, valid, message);
    }
    warningOnce.preMessage = preMessage;
    warningOnce.resetWarned = resetWarned;
    warningOnce.noteOnce = noteOnce2;
    var _default = exports.default = warningOnce;
  }
});

// src/index.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
import { CloseOutlined, CopyOutlined, DownOutlined, LockOutlined, UnlockOutlined, UpOutlined } from "@ant-design/icons";
import { getCompatContextProvider } from "react-querybuilder";

// src/AntDActionElement.tsx
import { jsx } from "react/jsx-runtime";
import { Button } from "antd";
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["className", "handleOnClick", "label", "title", "disabled", "disabledTranslation", "testID", "rules", "level", "path", "context", "validation", "ruleOrGroup", "schema"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var AntDActionElement = function AntDActionElement2(_ref) {
  var className = _ref.className, handleOnClick = _ref.handleOnClick, label = _ref.label, title = _ref.title, disabled = _ref.disabled, disabledTranslation = _ref.disabledTranslation, _testID = _ref.testID, _rules = _ref.rules, _level = _ref.level, _path = _ref.path, _context = _ref.context, _validation = _ref.validation, _ruleOrGroup = _ref.ruleOrGroup, _schema = _ref.schema, extraProps = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ jsx(Button, _objectSpread(_objectSpread({ type: "primary", className, title: disabledTranslation && disabled ? disabledTranslation.title : title, onClick: function onClick(e) {
    return handleOnClick(e);
  }, disabled: disabled && !disabledTranslation }, extraProps), {}, { children: disabledTranslation && disabled ? disabledTranslation.label : label }));
};

// src/AntDDragHandle.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
import { HolderOutlined } from "@ant-design/icons";
import { forwardRef } from "react";
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
var _excluded2 = ["className", "title", "testID", "level", "path", "label", "disabled", "context", "validation", "schema", "ruleOrGroup"];
function ownKeys2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
      _defineProperty2(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty2(e, r, t) {
  return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey2(t) {
  var i = _toPrimitive2(t, "string");
  return "symbol" == _typeof2(i) ? i : i + "";
}
function _toPrimitive2(t, r) {
  if ("object" != _typeof2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties2(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose2(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose2(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var AntDDragHandle = /* @__PURE__ */ forwardRef(function(_ref, dragRef) {
  var className = _ref.className, title = _ref.title, _testID = _ref.testID, _level = _ref.level, _path = _ref.path, _label = _ref.label, _disabled = _ref.disabled, _context = _ref.context, _validation = _ref.validation, _schema = _ref.schema, _ruleOrGroup = _ref.ruleOrGroup, extraProps = _objectWithoutProperties2(_ref, _excluded2);
  return /* @__PURE__ */ jsx2(HolderOutlined, _objectSpread2(_objectSpread2({ className, title }, extraProps), {}, { ref: dragRef }));
});

// src/AntDNotToggle.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
import { Switch } from "antd";
function _typeof3(o) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof3(o);
}
var _excluded3 = ["className", "handleOnChange", "label", "checked", "title", "disabled", "path", "context", "validation", "testID", "schema", "ruleGroup"];
function ownKeys3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys3(Object(t), true).forEach(function(r2) {
      _defineProperty3(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys3(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty3(e, r, t) {
  return (r = _toPropertyKey3(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey3(t) {
  var i = _toPrimitive3(t, "string");
  return "symbol" == _typeof3(i) ? i : i + "";
}
function _toPrimitive3(t, r) {
  if ("object" != _typeof3(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof3(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties3(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose3(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose3(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var AntDNotToggle = function AntDNotToggle2(_ref) {
  var className = _ref.className, handleOnChange = _ref.handleOnChange, label = _ref.label, checked = _ref.checked, title = _ref.title, disabled = _ref.disabled, _path = _ref.path, _context = _ref.context, _validation = _ref.validation, _testID = _ref.testID, _schema = _ref.schema, _ruleGroup = _ref.ruleGroup, extraProps = _objectWithoutProperties3(_ref, _excluded3);
  return /* @__PURE__ */ jsx3(Switch, _objectSpread3({ title, className, onChange: function onChange(v) {
    return handleOnChange(v);
  }, checked: !!checked, disabled, checkedChildren: label, unCheckedChildren: "=" }, extraProps));
};

// src/AntDShiftActions.tsx
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
import { Button as Button2 } from "antd";
var AntDShiftActions = function AntDShiftActions2(_ref) {
  var shiftUp = _ref.shiftUp, shiftDown = _ref.shiftDown, shiftUpDisabled = _ref.shiftUpDisabled, shiftDownDisabled = _ref.shiftDownDisabled, disabled = _ref.disabled, className = _ref.className, labels = _ref.labels, titles = _ref.titles, testID = _ref.testID;
  return /* @__PURE__ */ jsxs("div", { "data-testid": testID, className, children: [/* @__PURE__ */ jsx4(Button2, { type: "primary", size: "small", title: titles === null || titles === void 0 ? void 0 : titles.shiftUp, onClick: shiftUp, disabled: disabled || shiftUpDisabled, children: labels === null || labels === void 0 ? void 0 : labels.shiftUp }), /* @__PURE__ */ jsx4(Button2, { type: "primary", size: "small", title: titles === null || titles === void 0 ? void 0 : titles.shiftDown, onClick: shiftDown, disabled: disabled || shiftDownDisabled, children: labels === null || labels === void 0 ? void 0 : labels.shiftDown })] });
};

// src/AntDValueEditor.tsx
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
import { Checkbox, Input, InputNumber, Radio, Switch as Switch2 } from "antd";
import generatePicker from "antd/es/date-picker/generatePicker/index.js";
import dayjs2 from "dayjs";
import { joinWith, useValueEditor, ValueEditor } from "react-querybuilder";

// src/dayjs.ts
var import_warning = __toESM(require_warning());
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat.js";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import localeData from "dayjs/plugin/localeData.js";
import weekOfYear from "dayjs/plugin/weekOfYear.js";
import weekYear from "dayjs/plugin/weekYear.js";
import weekday from "dayjs/plugin/weekday.js";
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0, F = function F2() {
      };
      return { s: F, n: function n() {
        return _n >= r.length ? { done: true } : { done: false, value: r[_n++] };
      }, e: function e2(r2) {
        throw r2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a = true, u = false;
  return { s: function s() {
    t = t.call(r);
  }, n: function n() {
    var r2 = t.next();
    return a = r2.done, r2;
  }, e: function e2(r2) {
    u = true, o = r2;
  }, f: function f() {
    try {
      a || null == t["return"] || t["return"]();
    } finally {
      if (u) throw o;
    }
  } };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(function(o, c2) {
  var proto = c2.prototype;
  var oldFormat = proto.format;
  proto.format = function f(formatStr) {
    var str = (formatStr || "").replace("Wo", "wo");
    return oldFormat.bind(this)(str);
  };
});
var localeMap = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
};
var parseLocale = function parseLocale2(locale) {
  var mapLocale = localeMap[locale];
  return mapLocale || locale.split("_")[0];
};
var parseNoMatchNotice = function parseNoMatchNotice2() {
  (0, import_warning.noteOnce)(false, "Not match any format. Please help to fire a issue about this.");
};
var generateConfig = {
  // get
  getNow: function getNow() {
    return dayjs();
  },
  getFixedDate: function getFixedDate(string) {
    return dayjs(string, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function getEndDate(date) {
    return date.endOf("month");
  },
  getWeekDay: function getWeekDay(date) {
    var clone = date.locale("en");
    return clone.weekday() + clone.localeData().firstDayOfWeek();
  },
  getYear: function getYear(date) {
    return date.year();
  },
  getMonth: function getMonth(date) {
    return date.month();
  },
  getDate: function getDate(date) {
    return date.date();
  },
  getHour: function getHour(date) {
    return date.hour();
  },
  getMinute: function getMinute(date) {
    return date.minute();
  },
  getSecond: function getSecond(date) {
    return date.second();
  },
  getMillisecond: function getMillisecond(date) {
    return date.millisecond();
  },
  // set
  addYear: function addYear(date, diff) {
    return date.add(diff, "year");
  },
  addMonth: function addMonth(date, diff) {
    return date.add(diff, "month");
  },
  addDate: function addDate(date, diff) {
    return date.add(diff, "day");
  },
  setYear: function setYear(date, year) {
    return date.year(year);
  },
  setMonth: function setMonth(date, month) {
    return date.month(month);
  },
  setDate: function setDate(date, num) {
    return date.date(num);
  },
  setHour: function setHour(date, hour) {
    return date.hour(hour);
  },
  setMinute: function setMinute(date, minute) {
    return date.minute(minute);
  },
  setSecond: function setSecond(date, second) {
    return date.second(second);
  },
  setMillisecond: function setMillisecond(date, milliseconds) {
    return date.millisecond(milliseconds);
  },
  // Compare
  isAfter: function isAfter(date1, date2) {
    return date1.isAfter(date2);
  },
  isValidate: function isValidate(date) {
    return date.isValid();
  },
  locale: { getWeekFirstDay: function getWeekFirstDay(locale) {
    return dayjs().locale(parseLocale(locale)).localeData().firstDayOfWeek();
  }, getWeekFirstDate: function getWeekFirstDate(locale, date) {
    return date.locale(parseLocale(locale)).weekday(0);
  }, getWeek: function getWeek(locale, date) {
    return date.locale(parseLocale(locale)).week();
  }, getShortWeekDays: function getShortWeekDays(locale) {
    return dayjs().locale(parseLocale(locale)).localeData().weekdaysMin();
  }, getShortMonths: function getShortMonths(locale) {
    return dayjs().locale(parseLocale(locale)).localeData().monthsShort();
  }, format: function format(locale, date, _format) {
    return date.locale(parseLocale(locale)).format(_format);
  }, parse: function parse(locale, text, formats) {
    var localeStr = parseLocale(locale);
    var _iterator = _createForOfIteratorHelper(formats), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var format2 = _step.value;
        var formatText = text;
        if (format2.includes("wo") || format2.includes("Wo")) {
          var year = formatText.split("-")[0];
          var weekStr = formatText.split("-")[1];
          var firstWeek = dayjs(year, "YYYY").startOf("year").locale(localeStr);
          for (var j = 0; j <= 52; j += 1) {
            var nextWeek = firstWeek.add(j, "week");
            if (nextWeek.format("Wo") === weekStr) {
              return nextWeek;
            }
          }
          parseNoMatchNotice();
          return null;
        }
        var date = dayjs(formatText, format2, true).locale(localeStr);
        if (date.isValid()) {
          return date;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (text) {
      parseNoMatchNotice();
    }
    return null;
  } }
};
var dayjs_default = generateConfig;

// src/AntDValueEditor.tsx
function _typeof4(o) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof4(o);
}
var _excluded4 = ["fieldData", "operator", "value", "handleOnChange", "title", "className", "type", "values", "listsAsArrays", "separator", "valueSource", "disabled", "testID", "selectorComponent", "extraProps", "inputType", "parseNumbers"];
function ownKeys4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys4(Object(t), true).forEach(function(r2) {
      _defineProperty4(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys4(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty4(e, r, t) {
  return (r = _toPropertyKey4(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey4(t) {
  var i = _toPrimitive4(t, "string");
  return "symbol" == _typeof4(i) ? i : i + "";
}
function _toPrimitive4(t, r) {
  if ("object" != _typeof4(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof4(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties4(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose4(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose4(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var DatePicker = generatePicker(dayjs_default);
var AntDValueEditor = function AntDValueEditor2(allProps) {
  var _fieldData$placeholde;
  var fieldData = allProps.fieldData, operator = allProps.operator, value = allProps.value, handleOnChange = allProps.handleOnChange, title = allProps.title, className = allProps.className, type = allProps.type, _allProps$values = allProps.values, values = _allProps$values === void 0 ? [] : _allProps$values, listsAsArrays = allProps.listsAsArrays, separator = allProps.separator, _vs = allProps.valueSource, disabled = allProps.disabled, testID = allProps.testID, _allProps$selectorCom = allProps.selectorComponent, SelectorComponent = _allProps$selectorCom === void 0 ? allProps.schema.controls.valueSelector : _allProps$selectorCom, extraProps = allProps.extraProps, _inputType = allProps.inputType, _parseNumbers = allProps.parseNumbers, propsForValueSelector = _objectWithoutProperties4(allProps, _excluded4);
  var _useValueEditor = useValueEditor(allProps), valueAsArray = _useValueEditor.valueAsArray, multiValueHandler = _useValueEditor.multiValueHandler, valueListItemClassName = _useValueEditor.valueListItemClassName, inputTypeCoerced = _useValueEditor.inputTypeCoerced;
  if (operator === "null" || operator === "notNull") {
    return null;
  }
  var placeHolderText = (_fieldData$placeholde = fieldData === null || fieldData === void 0 ? void 0 : fieldData.placeholder) !== null && _fieldData$placeholde !== void 0 ? _fieldData$placeholde : "";
  if ((operator === "between" || operator === "notBetween") && (type === "select" || type === "text") && // Date ranges are handled differently in AntD--see below
  inputTypeCoerced !== "date" && inputTypeCoerced !== "datetime-local") {
    if (type === "text") {
      var editors = ["from", "to"].map(function(key, i) {
        var _valueAsArray$i2;
        if (inputTypeCoerced === "time") {
          return /* @__PURE__ */ jsx5(DatePicker.TimePicker, _objectSpread4({ value: valueAsArray[i] ? dayjs2(valueAsArray[i], "HH:mm:ss") : null, className: valueListItemClassName, disabled, placeholder: placeHolderText, onChange: function onChange(d) {
            var _d$format;
            return multiValueHandler((_d$format = d === null || d === void 0 ? void 0 : d.format("HH:mm:ss")) !== null && _d$format !== void 0 ? _d$format : "", i);
          } }, extraProps), key);
        } else if (inputTypeCoerced === "number") {
          var _valueAsArray$i;
          return /* @__PURE__ */ jsx5(InputNumber, _objectSpread4({ type: inputTypeCoerced, value: (_valueAsArray$i = valueAsArray[i]) !== null && _valueAsArray$i !== void 0 ? _valueAsArray$i : "", className: valueListItemClassName, disabled, placeholder: placeHolderText, onChange: function onChange(v) {
            return multiValueHandler(v, i);
          } }, extraProps), key);
        }
        return /* @__PURE__ */ jsx5(Input, _objectSpread4({ type: inputTypeCoerced, value: (_valueAsArray$i2 = valueAsArray[i]) !== null && _valueAsArray$i2 !== void 0 ? _valueAsArray$i2 : "", className: valueListItemClassName, disabled, placeholder: placeHolderText, onChange: function onChange(e) {
          return multiValueHandler(e.target.value, i);
        } }, extraProps), key);
      });
      return /* @__PURE__ */ jsxs2("span", { "data-testid": testID, className, title, children: [editors[0], separator, editors[1]] });
    }
    return /* @__PURE__ */ jsx5(ValueEditor, _objectSpread4(_objectSpread4({}, allProps), {}, { skipHook: true }));
  }
  switch (type) {
    case "select":
    case "multiselect":
      return /* @__PURE__ */ jsx5(SelectorComponent, _objectSpread4(_objectSpread4({}, propsForValueSelector), {}, { className, title, value, disabled, listsAsArrays, multiple: type === "multiselect", handleOnChange, options: values }, extraProps));
    case "textarea":
      return /* @__PURE__ */ jsx5(Input.TextArea, _objectSpread4({ value, title, className, disabled, placeholder: placeHolderText, onChange: function onChange(e_2) {
        return handleOnChange(e_2.target.value);
      } }, extraProps));
    case "switch":
      return /* @__PURE__ */ jsx5(Switch2, _objectSpread4({ checked: !!value, title, className, disabled, onChange: function onChange(v_1) {
        return handleOnChange(v_1);
      } }, extraProps));
    case "checkbox":
      return /* @__PURE__ */ jsx5("span", { title, className, children: /* @__PURE__ */ jsx5(Checkbox, _objectSpread4({ type: "checkbox", disabled, onChange: function onChange(e_1) {
        return handleOnChange(e_1.target.checked);
      }, checked: !!value }, extraProps)) });
    case "radio":
      return /* @__PURE__ */ jsx5("span", { className, title, children: values.map(function(v_0) {
        return /* @__PURE__ */ jsx5(Radio, _objectSpread4(_objectSpread4({ value: v_0.name, checked: value === v_0.name, disabled, onChange: function onChange(e_0) {
          return handleOnChange(e_0.target.value);
        } }, extraProps), {}, { children: v_0.label }), v_0.name);
      }) });
  }
  switch (inputTypeCoerced) {
    case "date":
    case "datetime-local": {
      if (operator === "between" || operator === "notBetween") {
        var dayjsArray = valueAsArray.slice(0, 2).map(function(v_2) {
          return dayjs2(v_2);
        });
        return /* @__PURE__ */ jsx5(DatePicker.RangePicker, _objectSpread4({ value: dayjsArray.every(function(d_1) {
          return d_1.isValid();
        }) ? dayjsArray : void 0, showTime: inputTypeCoerced === "datetime-local", className, disabled, placeholder: [placeHolderText, placeHolderText], onChange: (
          /* istanbul ignore next */
          function onChange(dates) {
            var timeFormat = inputTypeCoerced === "datetime-local" ? "THH:mm:ss" : "";
            var format2 = "YYYY-MM-DD".concat(timeFormat);
            var dateArray = dates === null || dates === void 0 ? void 0 : dates.map(function(d_2) {
              return d_2 !== null && d_2 !== void 0 && d_2.isValid() ? d_2.format(format2) : void 0;
            });
            handleOnChange(dateArray ? listsAsArrays ? dateArray : joinWith(dateArray, ",") : dates);
          }
        ) }, extraProps));
      }
      var dateValue_0 = dayjs2(value);
      return /* @__PURE__ */ jsx5(DatePicker, _objectSpread4({ value: dateValue_0.isValid() ? dateValue_0 : void 0, showTime: inputTypeCoerced === "datetime-local", className, disabled, placeholder: placeHolderText, onChange: function onChange(_d, dateString) {
        return handleOnChange(dateString);
      } }, extraProps));
    }
    case "time": {
      var dateValue = dayjs2(value, "HH:mm:ss");
      return /* @__PURE__ */ jsx5(DatePicker.TimePicker, _objectSpread4({ value: dateValue.isValid() ? dateValue : void 0, className, disabled, placeholder: placeHolderText, onChange: function onChange(d_0) {
        var _d_0$format;
        return handleOnChange((_d_0$format = d_0 === null || d_0 === void 0 ? void 0 : d_0.format("HH:mm:ss")) !== null && _d_0$format !== void 0 ? _d_0$format : "");
      } }, extraProps));
    }
    case "number": {
      return /* @__PURE__ */ jsx5(InputNumber, _objectSpread4({ type: inputTypeCoerced, value, title, className, disabled, placeholder: placeHolderText, onChange: handleOnChange }, extraProps));
    }
  }
  return /* @__PURE__ */ jsx5(Input, _objectSpread4({ type: inputTypeCoerced, value, title, className, disabled, placeholder: placeHolderText, onChange: function onChange(e_3) {
    return handleOnChange(e_3.target.value);
  } }, extraProps));
};

// ../../utils/react-compiler/react-compiler-runtime.ts
import * as React from "react";
var $empty = Symbol["for"]("react.memo_cache_sentinel");
function c(size) {
  return React.useMemo(
    function() {
      var $ = Array.from({ length: size });
      for (var ii = 0; ii < size; ii++) {
        $[ii] = $empty;
      }
      $[$empty] = true;
      return $;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}

// src/AntDValueSelector.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
import { Select } from "antd";
import * as React2 from "react";
import { joinWith as joinWith2, useValueSelector } from "react-querybuilder";
function _typeof5(o) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof5(o);
}
var _excluded5 = ["className", "handleOnChange", "options", "value", "title", "disabled", "multiple", "listsAsArrays", "testID", "rule", "rules", "level", "path", "context", "validation", "operator", "field", "fieldData", "schema"];
function ownKeys5(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread5(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys5(Object(t), true).forEach(function(r2) {
      _defineProperty5(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys5(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty5(e, r, t) {
  return (r = _toPropertyKey5(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey5(t) {
  var i = _toPrimitive5(t, "string");
  return "symbol" == _typeof5(i) ? i : i + "";
}
function _toPrimitive5(t, r) {
  if ("object" != _typeof5(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties5(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose5(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose5(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var AntDValueSelector = function AntDValueSelector2(t0) {
  var $ = c(32);
  var className;
  var disabled;
  var extraProps;
  var handleOnChange;
  var listsAsArrays;
  var multiple;
  var options;
  var title;
  var value;
  if ($[0] !== t0) {
    var _t = t0.className, _t2 = t0.handleOnChange, _t3 = t0.options, _t4 = t0.value, _t5 = t0.title, t6 = t0.disabled, t7 = t0.multiple, t8 = t0.listsAsArrays, _testID = t0.testID, _rule = t0.rule, _rules = t0.rules, _level = t0.level, _path = t0.path, _context = t0.context, _validation = t0.validation, _operator = t0.operator, _field = t0.field, _fieldData = t0.fieldData, _schema = t0.schema, t9 = _objectWithoutProperties5(t0, _excluded5);
    className = _t;
    handleOnChange = _t2;
    options = _t3;
    value = _t4;
    title = _t5;
    disabled = t6;
    multiple = t7;
    listsAsArrays = t8;
    extraProps = t9;
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = extraProps;
    $[4] = handleOnChange;
    $[5] = listsAsArrays;
    $[6] = multiple;
    $[7] = options;
    $[8] = title;
    $[9] = value;
  } else {
    className = $[1];
    disabled = $[2];
    extraProps = $[3];
    handleOnChange = $[4];
    listsAsArrays = $[5];
    multiple = $[6];
    options = $[7];
    title = $[8];
    value = $[9];
  }
  var t1;
  if ($[10] !== handleOnChange || $[11] !== value) {
    t1 = { handleOnChange, listsAsArrays: false, multiple: false, value };
    $[10] = handleOnChange;
    $[11] = value;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  var _useValueSelector = useValueSelector(t1), onChangeNoArrays = _useValueSelector.onChange;
  var t2 = multiple || listsAsArrays;
  var t3;
  if ($[13] !== handleOnChange || $[14] !== multiple || $[15] !== t2 || $[16] !== value) {
    t3 = { handleOnChange, listsAsArrays: t2, multiple, value };
    $[13] = handleOnChange;
    $[14] = multiple;
    $[15] = t2;
    $[16] = value;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  var _useValueSelector2 = useValueSelector(t3), onChangeNormal = _useValueSelector2.onChange, val = _useValueSelector2.val;
  var t4;
  if ($[18] !== listsAsArrays || $[19] !== multiple || $[20] !== onChangeNoArrays || $[21] !== onChangeNormal) {
    t4 = function t42(v) {
      if (multiple && !listsAsArrays && Array.isArray(v)) {
        onChangeNoArrays(joinWith2(v));
      } else {
        onChangeNormal(v);
      }
    };
    $[18] = listsAsArrays;
    $[19] = multiple;
    $[20] = onChangeNoArrays;
    $[21] = onChangeNormal;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  var onChange = t4;
  var t5;
  if ($[23] !== className || $[24] !== disabled || $[25] !== extraProps || $[26] !== multiple || $[27] !== onChange || $[28] !== options || $[29] !== title || $[30] !== val) {
    t5 = jsx6(Select, _objectSpread5(_objectSpread5({}, multiple ? { mode: "multiple", allowClear: true } : {}), {}, { title, className, popupMatchSelectWidth: false, disabled, value: val, onChange, optionFilterProp: "label", options }, extraProps));
    $[23] = className;
    $[24] = disabled;
    $[25] = extraProps;
    $[26] = multiple;
    $[27] = onChange;
    $[28] = options;
    $[29] = title;
    $[30] = val;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  return t5;
};

// src/index.tsx
var antdControlElements = { actionElement: AntDActionElement, dragHandle: AntDDragHandle, notToggle: AntDNotToggle, shiftActions: AntDShiftActions, valueEditor: AntDValueEditor, valueSelector: AntDValueSelector };
var antdTranslations = { removeGroup: { label: /* @__PURE__ */ jsx7(CloseOutlined, {}) }, removeRule: { label: /* @__PURE__ */ jsx7(CloseOutlined, {}) }, cloneRule: { label: /* @__PURE__ */ jsx7(CopyOutlined, {}) }, cloneRuleGroup: { label: /* @__PURE__ */ jsx7(CopyOutlined, {}) }, lockGroup: { label: /* @__PURE__ */ jsx7(UnlockOutlined, {}) }, lockRule: { label: /* @__PURE__ */ jsx7(UnlockOutlined, {}) }, lockGroupDisabled: { label: /* @__PURE__ */ jsx7(LockOutlined, {}) }, lockRuleDisabled: { label: /* @__PURE__ */ jsx7(LockOutlined, {}) }, shiftActionUp: { label: /* @__PURE__ */ jsx7(UpOutlined, {}) }, shiftActionDown: { label: /* @__PURE__ */ jsx7(DownOutlined, {}) } };
var QueryBuilderAntD = getCompatContextProvider({ controlElements: antdControlElements, translations: antdTranslations });
export {
  AntDActionElement,
  AntDDragHandle,
  AntDNotToggle,
  AntDShiftActions,
  AntDValueEditor,
  AntDValueSelector,
  QueryBuilderAntD,
  antdControlElements,
  antdTranslations
};
//# sourceMappingURL=react-querybuilder_antd.mjs.map